import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import './Dialogs.scss';

interface GeneratingCodeDialogProps {
  isOpen: boolean;
}

const GeneratingCodeDialog: React.FC<GeneratingCodeDialogProps> = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <Dialog title=" " width={400}>
      <div className="generating-code-dialog">
        <div className="loading-spinner">
          <svg
            width="50"
            height="50"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="spinner"
          >
            <path d="M21 12a9 9 0 11-6.219-8.56" />
          </svg>
        </div>
        <p className="generating-text">Generating code... Please wait</p>
      </div>
    </Dialog>
  );
};

export default GeneratingCodeDialog;
